import { useContext } from 'react'

import { CommissionFormContext } from '../context'

export function useUsers(role: 'partner' | 'employee') {
  const {
    partners,
    loadingPartners,
    listPartners,
    employees,
    loadingEmployees,
    listEmployees
  } = useContext(CommissionFormContext)

  if (role === 'partner') {
    return {
      users: partners,
      loading: loadingPartners,
      listUsers: listPartners
    }
  }

  return {
    users: employees,
    loading: loadingEmployees,
    listUsers: listEmployees
  }
}
